import { CommonModule, DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER,NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
//import { MatNativeDateModule } from '@angular/material';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { T4coreModule, UIService } from 't4core';
import { InsuranceCasesOverview } from '../apps/Service/Components/Insurance/Insurance';
import { ClaimCasesOverview } from '../apps/Service/Components/Claims/Claims';
/* Authentication */
import { T4BookingLink } from './components/bookingLink/bookingLink';
import { T4ContextTrace } from './components/contextTrace/contextTrace';
import { T4CustomerLink } from './components/customerLink/customerLink';
import { T4Dashboard } from './components/dashboard/dashboard';
import { T4KPI } from './components/kpi/t4kpi';
import { T4LocationLink } from './components/locationLink/locationLink';
import { ObjectInfoComponent } from './components/objectInfo/objectInfo.component';
import { T4ObjectLink } from './components/objectLink/objectLink';
import { ObjectListComponent } from './components/objectList/objectList.component';
import { T4PriceInfo } from './components/priceInfo/priceInfo';
import { T4ChartComponent } from './components/t4-chart/t4-chart.component';
import { T4Tooltip } from './components/t4Tooltip/t4Tooltip';
import { ThreeStateCheckBox } from './components/ThreeStateCheckBox/ThreeStateCheckBox';
import { ViewHeader } from './components/viewHeader/viewHeader.component';
import { T4DatatableWidget } from './components/datatable/datatable';
import { T4Report } from './components/report/report';
import { T4EntityEvent } from './components/entityevent/entityevent';
import { AmountDialog } from './dialogs/AmountDialog/AmountDialog';
import { CallDialog } from './dialogs/CallDialog/CallDialog';
import { createScheduledReportDialog } from './dialogs/createScheduledReportDialog/createScheduledReportDialog';
import { CreateServiceRequestDialog } from './dialogs/createServiceRequestDialog/createServiceRequestDialog';
import { CustomerDialog } from './dialogs/CustomerDialog/CustomerDialog';
import { FindBookingDialog } from './dialogs/findBookingDialog/findBookingDialog';
import { FindLocationDialog } from './dialogs/FindLocationDialog/FindLocationDialog';
import { ImageDialog } from './dialogs/ImageDialog/ImageDialog';
import { InsuranceImageInfoDialogComponent } from './dialogs/insurance-image-info-dialog/insurance-image-info-dialog.component';
import { InsuranceInfoDialogComponent } from './dialogs/insurance-info-dialog/insurance-info-dialog.component';
import { JsonDialog } from './dialogs/JsonDialog/JsonDialog';
import { NearbyOneWayAvailabilityDialog } from './dialogs/NearbyOneWayAvailabilityDialog/NearbyOneWayAvailabilityDialog';
import { ObjectDialog } from './dialogs/ObjectDialog/ObjectDialog';
import { RentalDialog } from './dialogs/rentaldialog/rentaldialog';
import { ReturnDialog } from './dialogs/returnDialog/returnDialog';
import { ServiceBookingDialog } from './dialogs/ServiceBookingDialog/ServiceBookingDialog';
import { SmsCodeDialog } from './dialogs/Signing/SmsCodeDialog/SmsCodeDialog';
import { SmsDialog } from './dialogs/SmsDialog/SmsDialog';
import { UploadImagesDialog } from './dialogs/uploadImagesDialog/uploadImagesDialog';
import { DialogService } from './services/dialog.service';
import { MatTreeModule } from '@angular/material/tree'
import { LocationInfoComponent } from '.';
import { RentalCustomerDetails } from "./components/RentalCustomerDetails/RentalCustomerDetails";
import { UploadImageDialog } from './dialogs/UploadImageDialog/UploadImageDialog';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { NgxEditorModule } from 'ngx-editor';
import { MdbChartDirective, MdbChartModule } from 'mdb-angular-ui-kit/charts';
import { T4UsedParts } from './components/usedparts/usedparts';
import { T4EntityAttachment } from './dialogs/entityattachment/entityattachment';
import { ObjectGpsMapComponent } from './components/object-gps-map/object-gps-map.component';
import { T4TranslationEditorComponent } from './components/t4-translation-editor/t4-translation-editor.component';
import { T4OrderCustomerLink } from './components/orderCustomerLink/orderCustomerLink';
import { T4OrderCustomerInfo } from './components/orderCustomerInfo/orderCustomerInfo';
import { T4GroupFilterComponent } from './components/t4-group-filter/t4-group-filter.component';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { T4ConditionEditorComponent } from './components/t4-condition-editor/t4-condition-editor.component'; 

@NgModule({
  imports: [        
        BrowserModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
        MatCheckboxModule,
        MatRadioModule,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatAutocompleteModule,
        MatSelectModule,
        //MatNativeDateModule,
        MatDatepickerModule,
        MatTabsModule,
        MatTooltipModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatProgressBarModule,
        MatIconModule,
        MatDialogModule,
        MatStepperModule,
        MatToolbarModule,
        MatListModule,
        MatChipsModule,
        MatMomentDateModule,
        MatButtonToggleModule,
        MatInputModule,
        MatTabsModule,
        MatFormFieldModule,
        T4coreModule,
        MatSlideToggleModule,
        MatSliderModule,
        MatExpansionModule,
        MatSnackBarModule,
        MatTreeModule,
        NgxImageZoomModule,
        MdbChartModule,
        NgxEditorModule,
        PickerModule,
        MatCardModule,
        MatDividerModule

    ],
    declarations: [
        ViewHeader,
        LocationInfoComponent,
        ObjectInfoComponent,
        ObjectListComponent,
        SmsDialog,
        RentalDialog,
        CallDialog,
        CreateServiceRequestDialog,
        FindLocationDialog,
        NearbyOneWayAvailabilityDialog,
        ObjectDialog,
        CustomerDialog,
        ServiceBookingDialog,
        ReturnDialog,
        createScheduledReportDialog,
        SmsCodeDialog,
        FindBookingDialog,
        T4Dashboard,
        T4DatatableWidget,
        T4BookingLink,
        T4CustomerLink,
        T4ObjectLink,
        T4Tooltip,
        T4PriceInfo,
        T4KPI,
        T4LocationLink,
        T4OrderCustomerLink,
        T4OrderCustomerInfo,
        T4ChartComponent,
        UploadImagesDialog,
        ImageDialog,
        InsuranceCasesOverview,
        ClaimCasesOverview,
        AmountDialog,
        InsuranceInfoDialogComponent,
        InsuranceImageInfoDialogComponent,
        ThreeStateCheckBox,
        JsonDialog,
        T4ContextTrace,
        T4Report,
        RentalCustomerDetails,
        UploadImageDialog,
        T4EntityEvent,
        T4UsedParts,
        T4EntityAttachment,
        ObjectGpsMapComponent,
        T4TranslationEditorComponent,
        T4GroupFilterComponent,
        T4ConditionEditorComponent
    ],
    exports: [
        ViewHeader,
        LocationInfoComponent,
        ObjectInfoComponent,
        T4Dashboard,
        T4DatatableWidget,
        T4BookingLink,
        T4CustomerLink,
        T4ObjectLink,
        T4Tooltip,
        T4PriceInfo,
        T4KPI,
        T4LocationLink,
        T4OrderCustomerLink,
        T4OrderCustomerInfo,
        ObjectListComponent,
        RentalDialog,
        SmsDialog,
        FindLocationDialog,
        createScheduledReportDialog,
        CustomerDialog,
        FindBookingDialog,
        DatePipe,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        MatPaginatorModule,
        MatCheckboxModule,
        MatRadioModule,
        MatListModule,
        MatSortModule,
        MatTableModule,
        MatAutocompleteModule,
        MatSelectModule,
        MatDatepickerModule,
        MatTabsModule,
        MatTooltipModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatMenuModule,
        MatProgressBarModule,
        MatDialogModule,
        MatStepperModule,
        MatIconModule,
        MatToolbarModule,
        MatChipsModule,
        MatButtonToggleModule,
        MatInputModule,
        MatFormFieldModule,
        MatCardModule,
        MatDividerModule,
        BrowserModule,
        CommonModule,
        MatTabsModule,
        MatSlideToggleModule,
        T4ChartComponent,
        MatSliderModule,
        MatExpansionModule,
        MatSnackBarModule,
        UploadImagesDialog,
        ImageDialog,
        InsuranceCasesOverview,
        ClaimCasesOverview,
        InsuranceInfoDialogComponent,
        InsuranceImageInfoDialogComponent,
        ThreeStateCheckBox,
        JsonDialog,
        T4ContextTrace,
        T4Report,
        MatTreeModule,
        RentalCustomerDetails,
        T4EntityEvent,
        T4UsedParts,
        ObjectGpsMapComponent,
        MdbChartModule,
        T4EntityAttachment,
        T4TranslationEditorComponent,
        T4GroupFilterComponent,
        T4ConditionEditorComponent
    ],
  providers: [DialogService, T4coreModule, { provide: APP_INITIALIZER, useFactory: initModule, deps: [UIService], multi: true }, provideHttpClient(withInterceptorsFromDi())]
})
export class T4CommonModule { }


// Module initialization
export function initModule(settings: UIService) {
  return () => {
    settings.applySettings({
      dialogs: [
        { key: "T4.Common.FindLocationDialog", dialog: FindLocationDialog },
        { key: "T4.Common.AmountDialog", dialog: AmountDialog },
        { key: "T4.Common.JsonDialog", dialog: JsonDialog },
        { key: "T4.Common.UploadImageDialog", dialog: UploadImageDialog }
      ]
    });
  };
}
// Module initialization
